/* unplugin-vue-components disabled */import { render } from "./ellipsis-fit.vue?vue&type=template&id=69499ac5"
import script from "./ellipsis-fit.vue?vue&type=script&lang=js"
export * from "./ellipsis-fit.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/ellipsis-fit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69499ac5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69499ac5', __exports__)) {
    api.reload('69499ac5', __exports__)
  }
  
  module.hot.accept("./ellipsis-fit.vue?vue&type=template&id=69499ac5", () => {
    api.rerender('69499ac5', render)
  })

}


export default __exports__